import React from "react";
import {
	Grid,
	Container,
	Card,
	// Segment,
	// Rail,
	// Sticky,
	// Header,
	// Image,
	// GridColumn,
} from "semantic-ui-react";
// import _ from "lodash";
import { actions, resources } from "../../shared/Literals";
import Can from "../../accessControls/Can";
import { Redirect } from "react-router";
import MediaLayout, { MediaProvider } from "../../layouts/MediaLayout";
import { Esvdv2Provider } from "../../providers/Esvdv2Provider";
import { UserProvider } from "../../providers/UserProvider";
import { ModalWithContextProvider } from "../../layouts/ModalWithContext";
import EarlyBirdListing from "./EarlyBirdListing";

const { Media, MediaContextProvider } = MediaLayout;

const EarlyBirdReadMe = () => {
	return (
		<Card fluid>
			<Card.Content>
				<h4 className="title-card">Read Me</h4>
			</Card.Content>
			<Card.Content></Card.Content>
		</Card>
	);
};

const EarlyBirdBoard = () => {
	const renderContent = () => {
		return (
			<Esvdv2Provider>
				<MediaContextProvider>
					<Media at="mobile" className="page-content">
						{/* <EarlyBirdReadMe /> */}
						<EarlyBirdListing />
					</Media>
					<Media greaterThan="mobile">
						<Container fluid className="top-container">
							<Grid columns={2} className="page-content" centered>
								<Grid.Row>
									<Grid.Column stretched>
										<EarlyBirdListing />
									</Grid.Column>
									{/* <Grid.Column width={4}>
										<EarlyBirdReadMe />
									</Grid.Column> */}
								</Grid.Row>
							</Grid>
						</Container>
					</Media>
				</MediaContextProvider>
			</Esvdv2Provider>
		);
	};
	return (
		<Can
			action={actions.read}
			resource={resources.admin.name}
			yes={() => renderContent()}
			no={() => <Redirect to={"/"} />}
		/>
	);
};

const EarlyBirdBoardwrapper = () => {
	return (
		<UserProvider>
			<MediaProvider>
				<ModalWithContextProvider>
					<EarlyBirdBoard />
				</ModalWithContextProvider>
			</MediaProvider>
		</UserProvider>
	);
};

export default EarlyBirdBoardwrapper;
